import { useHasFeature } from '@portal/env/hooks/useHasFeature';
import { useMemo } from 'react';
import { routes } from '@portal/env/routes';

interface PaymentRoutes {
  /**
   * First page of the checkout - shows the user's basket and has a button to
   * generate an invoice and start the payment flow
   */
  checkout: string;
  /**
   * Second page of the checkout - shows the user's invoice and has a button to
   * pay with Stripe
   */
  checkout_payment: string;

  /**
   * The checkout page but with a specific invoice pre-selected
   * @param invoiceId The id of the invoice to show
   */
  checkout_payment_invoice: (invoiceId: string) => string;
  /**
   * Confirmation page for a checkout where the user has paid an invoice
   */
  checkout_complete: string;
}

/**
 * Small helper to deal with routing around payments while we're still in
 * the phase of needing a feature flag for it.
 */
export const usePaymentRoutes = (): PaymentRoutes => {
  const hasNewPayments = useHasFeature('featureStripePayments');

  return useMemo(() => {
    if (hasNewPayments) {
      return {
        checkout: routes.checkout,
        checkout_payment: routes.checkout_payment,
        checkout_payment_invoice: (invoiceId) =>
          routes.checkout_payment + `?invoice=${encodeURIComponent(invoiceId)}`,
        checkout_complete: routes.checkout_complete,
      };
    }
    return {
      checkout: routes.spreedlycheckout,
      checkout_payment: routes.spreedlycheckout_payment,
      checkout_complete: routes.spreedlycheckout_complete,
      checkout_payment_invoice: () => routes.spreedlycheckout_payment,
    };
  }, [hasNewPayments]);
};
